import { resolveOutboundPlaybookCallsEnabled } from "@repo/common";
import { db } from "@repo/ui";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import type { Company } from "../types";

export function useOutboundPlaybookFeatureFlag(
	companyId?: string | null,
	companyProfile?: Company | null,
) {
	const [enabled, setEnabled] = useState(false);

	useEffect(() => {
		if (!companyId) {
			setEnabled(false);
			return;
		}

		return onSnapshot(
			doc(db, "settings", "system"),
			(snapshot) => {
				setEnabled(
					resolveOutboundPlaybookCallsEnabled(
						snapshot.exists() ? snapshot.data() : null,
						companyProfile,
					),
				);
			},
			(error) => {
				console.error("Failed to load outbound Playbook feature flag", error);
				setEnabled(false);
			},
		);
	}, [companyId, companyProfile]);

	return enabled;
}
